<template>
    <b-card no-body>
        <b-card-body>
            <Filters
              :filters="filters"
              :perPage="perPage"
              :pageOptions="pageOptions"
              @get-Orders-by-Date-Range-filter="getOrdersByDateRangeFilter"
              @change-per-page="changePerPage"
              @clear-filter="resetFilter"
            />

            <div v-if="isloadingProcess" class="text-center p-1 my-2">
                <b-spinner class="align-middle"></b-spinner> <br>
                <strong>Cargando grupos</strong>
            </div>

            <Roomlist
              v-else
              :filteredOrders="groupsData"
              :fields="fieldsRooms"
            />

            <PaginationTable
              :currentPage="currentPage"
              :totalRows="filteredOrders.length"
              :perPage="perPage"
              @change-page="changePage"
              v-if="filteredOrders.length"
            />

        </b-card-body>
    </b-card>
</template>

<script>
//eslint-disable-line
import * as moment from 'moment'
import { mapActions, mapState, mapGetters } from 'vuex'
import { fieldsRooms, filtroDataCliente } from '@/data/data'
import { currentDate, deleteNulls, yearsMinMax } from '@/helpers/helpers'

import Filters from '@/modules/groups/components/Filters'
import Roomlist from '@/modules/groups/components/Roomlist'
import PaginationTable from '@/modules/groups/components/PaginationTable'

export default {
    async created() {
        await this.fetchGroups(this.filters)
    },
    components: {
        //SFC
        Filters,
        Roomlist,
        PaginationTable
    },
    data() {
        return {
            fieldsRooms,
            filtroDataCliente,
            filter: null,
            perPage: 10,
            dateYYMM: moment().format("YYYY-MM"),
            dateCurrentInit: '',
            dateCurrentEnd: '',
            hotel: 0,
            fechaActual: currentDate(),
            minYearMax: yearsMinMax(),
            pageOptions: [5, 10, 15, { value: 100, text: "Todos" }],
            totalRows: 1,
            currentPage: 1,
            filterOn: [],
            sortBy: '',
            sortDesc: false,
            sortDirection: 'asc',
            cancelMotive: [],
            filters: {
                typegroup: this.$route.query.typegroup || null,
                fini: this.$route.query.fini || null,
                ffin: this.$route.query.ffin || null,
                weddingId: this.$route.query.weddingId || null,
                name: this.$route.query.name || null
            }
        }
    },
    watch: {
        async $route(to, from) { // detecto cambios en la URL sin tener que refrescar la página
            this.filters = {
                typegroup: this.$route.query.typegroup || null,
                fini: this.$route.query.fini || null,
                ffin: this.$route.query.ffin || null,
                name: this.$route.query.name || null,
                weddingId: this.$route.query.weddingId || null
            }
            await this.fetchGroups(this.filters)
        }
    },
    computed: {
        ...mapState('groups', ['isloadingProcess']),
        ...mapGetters('groups', ['filteredOrders']),

        groupsData() {
            if (this.filteredOrders?.length) return this.filteredOrders.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage)
            else return []
        },
    },
    methods: {
        ...mapActions('groups', ['fetchGroups', 'fetchRoomsUpdate']),
        async getOrdersByDateRangeFilter(data) {
            await this.changeURL(data)
        },
        async resetFilter() {
            this.filters = {
                typegroup: null,
                fini: null,
                ffin: null,
                name: null,
                weddingId: null
            }
            await this.changeURL(this.filters)
        },
        changePerPage(data) {
            this.perPage = data
        },
        changePage(page) {
            this.currentPage = page
        },
        async refresh() {
            await this.fetchRoomsUpdate(this.filters)
        },
        async changeURL(params) {
            this.$router.push({
                name: this.$route.name,
                query: {
                    ...deleteNulls(params)
                }
            }).catch(async err => {
                // Ignore the vuex err regarding navigating to the page they are already on.
                if (err.name == 'NavigationDuplicated' || err.message.includes('Avoided redundant navigation to current location')) {
                    await this.fetchGroups(params)
                } else console.error(err);
            });
        }
    },
}
</script>